import { Component, Input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

// Header bar for form dialogs: heading, optional subheading, an optional context chip
// (e.g. "Payer VNS") and a close button. Use with the 'form-dialog' panel class.
@Component({
    selector: 'app-dialog-header',
    imports: [MatDialogTitle, MatDialogClose, MatIconButton, MatIcon],
    templateUrl: './dialog-header.component.html',
    styleUrl: './dialog-header.component.scss'
})
export class DialogHeaderComponent {
  @Input({ required: true }) heading = '';
  @Input() subheading = '';
  @Input() contextLabel = '';
  @Input() contextValue: string | null | undefined = null;
  @Input() showClose = true;
  // Value the dialog closes with when the X is clicked (e.g. whether anything was saved).
  @Input() closeResult: unknown = undefined;
}
